import { themeToUiKitButton } from '@src/helpers/uikit'
import type { ReactNode } from 'react'
import { Button } from '../button/Button.component'
import styles from './InstagramSection.module.scss'

export interface InstagramSectionProps {
  title: string
  hashtag: string
  buttonCta: string
  instagram: InstagramNode[]
}

interface InstagramNode {
  id: string
  username: string
  media_url: string
  caption: string
}

export function InstagramSection({
  title,
  hashtag,
  buttonCta,
  instagram,
}: InstagramSectionProps): ReactNode {
  return (
    <section className={styles.InstagramSection}>
      <h3 className={styles.InstagramSection__title}>{title}</h3>
      <h4 className={styles.InstagramSection__hashtag}>{hashtag}</h4>
      <div className={styles.InstagramSection__images}>
        {instagram.map(({ id, media_url, caption }) => (
          <img
            className={styles.InstagramSection__image}
            key={id}
            src={media_url}
            alt={caption}
            loading="lazy"
          />
        ))}
      </div>
      <div className={styles.InstagramSection__button}>
        <Button
          {...themeToUiKitButton('brandPurple')}
          href="https://www.instagram.com/naturalcycles"
        >
          <div className={styles.InstagramSection__buttonInner}>
            <img alt="Instagram" src="/icons/instagram-white.svg" width={24} height={24} />
            {buttonCta}
          </div>
        </Button>
      </div>
    </section>
  )
}
